import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import UI from '../../common/UI';
import useProject from '../useProject';

export interface CommunicationLayoutProps {
  children: ReactNode;
}

const CommunicationLayout = ({ children }: CommunicationLayoutProps) => {
  const { t } = useTranslation();
  const project = useProject();

  return (
    <>
      <UI.Hero>
        <UI.Container sc={{ compact: true, pt: 0.5, px: [0, 4], textAlign: [undefined, 'center'] }}>
          <UI.Tabs>
            <UI.Tab to={`/${project.id}/communication/messages`}>{t('messages')}</UI.Tab>
            <UI.Tab to={`/${project.id}/communication/permissions`}>{t('mail_permissions')}</UI.Tab>
          </UI.Tabs>
        </UI.Container>
      </UI.Hero>

      <UI.Div id="CommunicationTab">
        {children}
      </UI.Div>
    </>
  );
};

export default CommunicationLayout;
